import type { IxcRaglV1TransactionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const RAGL_TRANSACTION_BASE_PATH = getResolvedPath('/clearing/operations/transaction');

export const getRaglTransactionPath: EntityPathBuilder<IxcRaglV1TransactionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return RAGL_TRANSACTION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.transactionId) {
        return undefined;
      }

      return getResolvedPath(`${RAGL_TRANSACTION_BASE_PATH}/$transactionId`, context.keys);
    }
  }
};

export function getRaglTransactionDetailPath(transactionId: string | undefined) {
  if (!transactionId) {
    return undefined;
  }

  return getRaglTransactionPath({ kind: 'detail', keys: { transactionId } });
}
